export var isObjectEmpty = function (obj) { return Object.keys(obj).length === 0; };
